import { ModalButton, ModalProps, ModalService } from '@philips-internal/oswald-ui-components';
import { ModalButtonType } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

interface Response {
  body: string;
  headers?: Record<string, Value>;
  status?: number;
  statusText?: string;
}

export enum DialogType {
  ACTION = 'action',
  ALERT = 'alert',
  AWAIT = 'await'
}

export enum ModalType {
  DEFAULT = 'default',
  DIALOG = 'dialog',
  FULL_SCREEN = 'fullscreen'
}

export interface SimpleDialogParams {
  buttons?: ModalButton[];
  closeable: boolean;
  descriptionDialog?: string;
  dialogType: DialogType;
  fragment?: string;
  modalType: ModalType;
  onClickCancel?: () => void;
  onClickOk?: () => void;
  titleDialog: string;
  titleOnCancel?: string;
  titleOnOk: string;
  theme: string;
}

export class SimpleDialog {

  private static buttonsActionDialog( simpleDialogParams: SimpleDialogParams ):  ModalButton[] {

    const onClickCancel = simpleDialogParams.onClickCancel ? simpleDialogParams.onClickCancel : undefined;
    const onClickOk = simpleDialogParams.onClickOk ? simpleDialogParams.onClickOk : undefined;

    const actions: ModalButton[] = [];

    if ( onClickCancel ) {
      actions.push({
        action: ()=>{onClickCancel();},
        title: simpleDialogParams.titleOnCancel ? simpleDialogParams.titleOnCancel : '',
        type: ModalButtonType.CANCEL,
      });
    }

    if ( onClickOk ) {
      actions.push({
        action: ()=>{onClickOk();},
        title:simpleDialogParams.titleOnOk,
        type: ModalButtonType.SUCCESS,
      });
    }
    return actions;
  }

  private static buttonsAlertDialog( simpleDialogParams: SimpleDialogParams ):  ModalButton[] {

    const actions = [];

    if ( simpleDialogParams.onClickOk ) {
      const onClickOk = simpleDialogParams.onClickOk;
      actions.push({
        action: ()=>{onClickOk();},
        title:simpleDialogParams.titleOnOk,
        type: ModalButtonType.SUCCESS,
      });
    }
    return actions;
  }

  static openDialog( simpleDialogParams: SimpleDialogParams ): void {

    let buttons: ModalButton[] = [];

    if ( !simpleDialogParams.buttons ) {
      switch ( simpleDialogParams.dialogType ) {
        case DialogType.ACTION : buttons = this.buttonsActionDialog( simpleDialogParams );
          break;
        case DialogType.ALERT : buttons = this.buttonsAlertDialog( simpleDialogParams );
          break;
        default:
          break;
      }
    } else {
      buttons = simpleDialogParams.buttons;
    }

    const dialogModal: ModalProps = {
      closeable: simpleDialogParams.closeable,
      dialogDescription: simpleDialogParams.fragment ? undefined : simpleDialogParams.descriptionDialog,
      dockButtons: buttons,
      fragment: simpleDialogParams.fragment,
      title: simpleDialogParams.titleDialog,
      closeByDocument: false,
      closeByEscape: false,
      focusOnOpen: false,
      uuid: '',
    };

    if ( simpleDialogParams.modalType ) {
      switch ( simpleDialogParams.modalType ) {
        case ModalType.DIALOG : ModalService.openDialog( dialogModal );
          break;
        case ModalType.FULL_SCREEN : ModalService.openFullscreen( dialogModal );
          break;
        default:  ModalService.openDefault( dialogModal );
          break;
      }
    }
  }

  static showMessageDialog( title: string, description: string, theme: string, onClickOk: () => void ): void {

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: description,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: onClickOk,
      titleDialog: title,
      titleOnOk: 'OK',
      theme: theme,
    };
    SimpleDialog.openDialog( dialogParams );
  }

  static showErrorMessage( err: Response | string, theme: string, onClickOk?: () => void, title?: string ): void {

    const dialogTitle = title && title.length > 0 ? title : MessageService.translate('approval.error');
    const onClick = onClickOk ? onClickOk : ()=> undefined;
    let errorMessage = '';

    const error = err as Response;

    if ( error.status === 500 && error.statusText ) {
      errorMessage = error.statusText;
    } else if ( error.body && error.body.length > 0 ) {
      errorMessage = error.body.replace( /[#@#@]/g, '' );
    } else {
      if ( error.status ) {
        errorMessage = error.status.toString();
      }

      if ( error.statusText ) {
        if ( errorMessage.length > 0 ) {
          errorMessage = `${errorMessage} - ${error.statusText}`;
        } else {
          errorMessage = error.statusText;
        }
      } else {
        errorMessage = err.toString() ;
      }
    }

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: errorMessage,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: onClick,
      titleDialog: dialogTitle,
      titleOnOk: 'OK',
      theme: theme,
    };
    SimpleDialog.openDialog( dialogParams );
  }

  static showWarningMessage( warningMessage: string, theme: string, onClickOk?: () => void, title?: string ): void {

    const dialogTitle = title && title.length > 0 ? title : 'Aviso';
    const onClick = onClickOk ? onClickOk : ()=> undefined;

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: warningMessage,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: onClick,
      titleDialog: dialogTitle,
      titleOnOk: 'OK',
      theme: theme,
    };
    SimpleDialog.openDialog( dialogParams );
  }
}
